import { type Receipt, type Transaction } from '@/types/payments';
import { addDays, subDays } from 'date-fns';

// Mock Receipts Data - UK-centric with all GBP currency
export const generateMockReceipts = (): Receipt[] => {
  return [
    // TEST RECEIPT FOR PROMISE TO PAY (Phase 2)
    {
      id: 1,
      receiptNumber: 'RCP-2025-001',
      customerId: 1,
      customerName: 'ABC Company Ltd',
      customerAccountNumber: 'ACC-001',
      receiptDate: new Date('2025-01-15'),
      receivedAmount: 1250.00,
      allocatedAmount: 0,
      unappliedAmount: 1250.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BACS-12345',
      bankReference: 'REF-2025-001',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FS-001',
      importedAt: new Date('2025-01-15'),
      createdBy: 'system',
      createdAt: new Date('2025-01-15'),
      notes: 'Payment received via bank transfer - MATCHES PROMISE',
      hasPromise: true,
      promiseToPayId: 1,
    },
    // MAIN TEST RECEIPT FOR ALLOCATION WORKSPACE
    {
      id: 101,
      receiptNumber: 'REC-001',
      customerId: 101,
      customerName: 'Acme Distribution Ltd',
      customerAccountNumber: 'ACC-1001',
      receiptDate: new Date('2025-11-10'),
      receivedAmount: 5000.00,
      allocatedAmount: 0,
      unappliedAmount: 5000.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'REF-884523',
      bankReference: 'REF-884523',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-001',
      importedAt: new Date('2025-11-10'),
      createdBy: 'system',
      createdAt: new Date('2025-11-10'),
      hasPromise: false,
    },
    {
      id: 102,
      receiptNumber: 'RCP-002',
      customerId: 102,
      customerName: 'Tech Solutions Inc',
      customerAccountNumber: 'ACC-002',
      receiptDate: new Date(),
      receivedAmount: 3200.00,
      allocatedAmount: 2000.00,
      unappliedAmount: 1200.00,
      currency: 'GBP',
      paymentMethod: 'credit_card',
      paymentReference: 'CC-67890',
      allocationStatus: 'partially_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-002',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 103,
      receiptNumber: 'RCP-003',
      customerId: 103,
      customerName: 'Global Retail Shop Inc',
      customerAccountNumber: 'ACC-003',
      receiptDate: subDays(new Date(), 1),
      receivedAmount: 8500.00,
      allocatedAmount: 8500.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-54321',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-003',
      importedAt: subDays(new Date(), 1),
      createdBy: 'system',
      createdAt: subDays(new Date(), 1),
      hasPromise: false,
    },
    {
      id: 104,
      receiptNumber: 'RCP-004',
      customerId: 104,
      customerName: 'Manufacturing Co Ltd',
      customerAccountNumber: 'ACC-004',
      receiptDate: subDays(new Date(), 2),
      receivedAmount: 12500.00,
      allocatedAmount: 0,
      unappliedAmount: 12500.00,
      currency: 'GBP',
      paymentMethod: 'direct_debit',
      paymentReference: 'DD-11111',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-004',
      importedAt: subDays(new Date(), 2),
      createdBy: 'system',
      createdAt: subDays(new Date(), 2),
      hasPromise: false,
    },
    {
      id: 105,
      receiptNumber: 'RCP-005',
      customerId: 105,
      customerName: 'Services Group PLC',
      customerAccountNumber: 'ACC-005',
      receiptDate: subDays(new Date(), 3),
      receivedAmount: 7800.00,
      allocatedAmount: 5000.00,
      unappliedAmount: 2800.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-99999',
      allocationStatus: 'partially_allocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-005',
      importedAt: subDays(new Date(), 3),
      createdBy: 'system',
      createdAt: subDays(new Date(), 3),
      hasPromise: true,
      promiseToPayId: 102,
    },
    {
      id: 106,
      receiptNumber: 'RCP-006',
      customerId: 106,
      customerName: 'Digital Media Ltd',
      customerAccountNumber: 'ACC-006',
      receiptDate: subDays(new Date(), 5),
      receivedAmount: 4500.00,
      allocatedAmount: 0,
      unappliedAmount: 4500.00,
      currency: 'GBP',
      paymentMethod: 'cheque',
      paymentReference: 'CHQ-12345',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-006',
      importedAt: subDays(new Date(), 5),
      createdBy: 'system',
      createdAt: subDays(new Date(), 5),
      hasPromise: false,
    },
    {
      id: 107,
      receiptNumber: 'RCP-007',
      customerId: 107,
      customerName: 'Construction Partners Ltd',
      customerAccountNumber: 'ACC-007',
      receiptDate: subDays(new Date(), 7),
      receivedAmount: 15000.00,
      allocatedAmount: 15000.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-77777',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-007',
      importedAt: subDays(new Date(), 7),
      createdBy: 'system',
      createdAt: subDays(new Date(), 7),
      hasPromise: false,
    },
    {
      id: 108,
      receiptNumber: 'RCP-008',
      customerId: 108,
      customerName: 'Healthcare Systems Inc',
      customerAccountNumber: 'ACC-008',
      receiptDate: subDays(new Date(), 10),
      receivedAmount: 9200.00,
      allocatedAmount: 3000.00,
      unappliedAmount: 6200.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-88888',
      allocationStatus: 'partially_allocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-008',
      importedAt: subDays(new Date(), 10),
      createdBy: 'system',
      createdAt: subDays(new Date(), 10),
      hasPromise: false,
    },
    // Additional unallocated receipts to meet threshold
    {
      id: 109,
      receiptNumber: 'RCP-009',
      customerId: 109,
      customerName: 'Retail Solutions Ltd',
      customerAccountNumber: 'ACC-009',
      receiptDate: subDays(new Date(), 4),
      receivedAmount: 3500.00,
      allocatedAmount: 0,
      unappliedAmount: 3500.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-10001',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-009',
      importedAt: subDays(new Date(), 4),
      createdBy: 'system',
      createdAt: subDays(new Date(), 4),
      hasPromise: false,
    },
    {
      id: 110,
      receiptNumber: 'RCP-010',
      customerId: 110,
      customerName: 'Logistics Express Inc',
      customerAccountNumber: 'ACC-010',
      receiptDate: subDays(new Date(), 6),
      receivedAmount: 5200.00,
      allocatedAmount: 0,
      unappliedAmount: 5200.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-10002',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-010',
      importedAt: subDays(new Date(), 6),
      createdBy: 'system',
      createdAt: subDays(new Date(), 6),
      hasPromise: false,
    },
    {
      id: 111,
      receiptNumber: 'RCP-011',
      customerId: 111,
      customerName: 'Professional Services Co',
      customerAccountNumber: 'ACC-011',
      receiptDate: subDays(new Date(), 8),
      receivedAmount: 6800.00,
      allocatedAmount: 0,
      unappliedAmount: 6800.00,
      currency: 'GBP',
      paymentMethod: 'credit_card',
      paymentReference: 'CC-10003',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-011',
      importedAt: subDays(new Date(), 8),
      createdBy: 'system',
      createdAt: subDays(new Date(), 8),
      hasPromise: false,
    },
    {
      id: 112,
      receiptNumber: 'RCP-012',
      customerId: 112,
      customerName: 'Energy Solutions PLC',
      customerAccountNumber: 'ACC-012',
      receiptDate: subDays(new Date(), 9),
      receivedAmount: 4200.00,
      allocatedAmount: 0,
      unappliedAmount: 4200.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-10004',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-012',
      importedAt: subDays(new Date(), 9),
      createdBy: 'system',
      createdAt: subDays(new Date(), 9),
      hasPromise: false,
    },
    {
      id: 113,
      receiptNumber: 'RCP-013',
      customerId: 113,
      customerName: 'Marketing Agency Ltd',
      customerAccountNumber: 'ACC-013',
      receiptDate: subDays(new Date(), 11),
      receivedAmount: 7500.00,
      allocatedAmount: 0,
      unappliedAmount: 7500.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-10005',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-013',
      importedAt: subDays(new Date(), 11),
      createdBy: 'system',
      createdAt: subDays(new Date(), 11),
      hasPromise: false,
    },
    {
      id: 114,
      receiptNumber: 'RCP-014',
      customerId: 114,
      customerName: 'Financial Advisors Inc',
      customerAccountNumber: 'ACC-014',
      receiptDate: subDays(new Date(), 12),
      receivedAmount: 3900.00,
      allocatedAmount: 0,
      unappliedAmount: 3900.00,
      currency: 'GBP',
      paymentMethod: 'direct_debit',
      paymentReference: 'DD-10006',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-014',
      importedAt: subDays(new Date(), 12),
      createdBy: 'system',
      createdAt: subDays(new Date(), 12),
      hasPromise: false,
    },
    {
      id: 115,
      receiptNumber: 'RCP-015',
      customerId: 115,
      customerName: 'Transport Group Ltd',
      customerAccountNumber: 'ACC-015',
      receiptDate: subDays(new Date(), 13),
      receivedAmount: 8900.00,
      allocatedAmount: 0,
      unappliedAmount: 8900.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-10007',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-015',
      importedAt: subDays(new Date(), 13),
      createdBy: 'system',
      createdAt: subDays(new Date(), 13),
      hasPromise: false,
    },
    {
      id: 116,
      receiptNumber: 'RCP-016',
      customerId: 116,
      customerName: 'Consulting Partners PLC',
      customerAccountNumber: 'ACC-016',
      receiptDate: subDays(new Date(), 14),
      receivedAmount: 5600.00,
      allocatedAmount: 0,
      unappliedAmount: 5600.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-10008',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-016',
      importedAt: subDays(new Date(), 14),
      createdBy: 'system',
      createdAt: subDays(new Date(), 14),
      hasPromise: false,
    },
    {
      id: 117,
      receiptNumber: 'RCP-017',
      customerId: 117,
      customerName: 'Technology Ventures Ltd',
      customerAccountNumber: 'ACC-017',
      receiptDate: subDays(new Date(), 15),
      receivedAmount: 4700.00,
      allocatedAmount: 0,
      unappliedAmount: 4700.00,
      currency: 'GBP',
      paymentMethod: 'cheque',
      paymentReference: 'CHQ-10009',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-017',
      importedAt: subDays(new Date(), 15),
      createdBy: 'system',
      createdAt: subDays(new Date(), 15),
      hasPromise: false,
    },
    {
      id: 118,
      receiptNumber: 'RCP-018',
      customerId: 118,
      customerName: 'Property Management Co',
      customerAccountNumber: 'ACC-018',
      receiptDate: subDays(new Date(), 16),
      receivedAmount: 6300.00,
      allocatedAmount: 0,
      unappliedAmount: 6300.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-10010',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-018',
      importedAt: subDays(new Date(), 16),
      createdBy: 'system',
      createdAt: subDays(new Date(), 16),
      hasPromise: false,
    },
    {
      id: 119,
      receiptNumber: 'RCP-019',
      customerId: 119,
      customerName: 'Insurance Brokers Ltd',
      customerAccountNumber: 'ACC-019',
      receiptDate: subDays(new Date(), 17),
      receivedAmount: 5400.00,
      allocatedAmount: 0,
      unappliedAmount: 5400.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-10011',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-019',
      importedAt: subDays(new Date(), 17),
      createdBy: 'system',
      createdAt: subDays(new Date(), 17),
      hasPromise: false,
    },
    {
      id: 120,
      receiptNumber: 'RCP-020',
      customerId: 120,
      customerName: 'Education Services Inc',
      customerAccountNumber: 'ACC-020',
      receiptDate: subDays(new Date(), 18),
      receivedAmount: 7200.00,
      allocatedAmount: 0,
      unappliedAmount: 7200.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-10012',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-020',
      importedAt: subDays(new Date(), 18),
      createdBy: 'system',
      createdAt: subDays(new Date(), 18),
      hasPromise: false,
    },
    {
      id: 121,
      receiptNumber: 'RCP-021',
      customerId: 121,
      customerName: 'Hospitality Group PLC',
      customerAccountNumber: 'ACC-021',
      receiptDate: subDays(new Date(), 19),
      receivedAmount: 4100.00,
      allocatedAmount: 0,
      unappliedAmount: 4100.00,
      currency: 'GBP',
      paymentMethod: 'credit_card',
      paymentReference: 'CC-10013',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-021',
      importedAt: subDays(new Date(), 19),
      createdBy: 'system',
      createdAt: subDays(new Date(), 19),
      hasPromise: false,
    },
    {
      id: 122,
      receiptNumber: 'RCP-022',
      customerId: 122,
      customerName: 'Engineering Solutions Ltd',
      customerAccountNumber: 'ACC-022',
      receiptDate: subDays(new Date(), 20),
      receivedAmount: 8600.00,
      allocatedAmount: 0,
      unappliedAmount: 8600.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-10014',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-022',
      importedAt: subDays(new Date(), 20),
      createdBy: 'system',
      createdAt: subDays(new Date(), 20),
      hasPromise: false,
    },
    {
      id: 123,
      receiptNumber: 'RCP-023',
      customerId: 123,
      customerName: 'Legal Services Co',
      customerAccountNumber: 'ACC-023',
      receiptDate: subDays(new Date(), 21),
      receivedAmount: 5900.00,
      allocatedAmount: 0,
      unappliedAmount: 5900.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-10015',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-023',
      importedAt: subDays(new Date(), 21),
      createdBy: 'system',
      createdAt: subDays(new Date(), 21),
      hasPromise: false,
    },
    {
      id: 124,
      receiptNumber: 'RCP-024',
      customerId: 124,
      customerName: 'Pharmaceutical Distributors Ltd',
      customerAccountNumber: 'ACC-024',
      receiptDate: subDays(new Date(), 22),
      receivedAmount: 9800.00,
      allocatedAmount: 0,
      unappliedAmount: 9800.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-10016',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-024',
      importedAt: subDays(new Date(), 22),
      createdBy: 'system',
      createdAt: subDays(new Date(), 22),
      hasPromise: false,
    },
    {
      id: 125,
      receiptNumber: 'RCP-025',
      customerId: 125,
      customerName: 'Telecommunications Inc',
      customerAccountNumber: 'ACC-025',
      receiptDate: subDays(new Date(), 23),
      receivedAmount: 6700.00,
      allocatedAmount: 0,
      unappliedAmount: 6700.00,
      currency: 'GBP',
      paymentMethod: 'direct_debit',
      paymentReference: 'DD-10017',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-025',
      importedAt: subDays(new Date(), 23),
      createdBy: 'system',
      createdAt: subDays(new Date(), 23),
      hasPromise: false,
    },
    // Additional receipts received TODAY for dashboard metrics
    {
      id: 126,
      receiptNumber: 'RCP-026',
      customerId: 126,
      customerName: 'Digital Marketing Co',
      customerAccountNumber: 'ACC-026',
      receiptDate: new Date(),
      receivedAmount: 4500.00,
      allocatedAmount: 4500.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BT-20001',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-026',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 127,
      receiptNumber: 'RCP-027',
      customerId: 127,
      customerName: 'Cloud Services Ltd',
      customerAccountNumber: 'ACC-027',
      receiptDate: new Date(),
      receivedAmount: 7800.00,
      allocatedAmount: 7800.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'credit_card',
      paymentReference: 'CC-20002',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-027',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 128,
      receiptNumber: 'RCP-028',
      customerId: 128,
      customerName: 'Software Development Inc',
      customerAccountNumber: 'ACC-028',
      receiptDate: new Date(),
      receivedAmount: 12500.00,
      allocatedAmount: 12500.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BT-20003',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-028',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 129,
      receiptNumber: 'RCP-029',
      customerId: 129,
      customerName: 'Consulting Group',
      customerAccountNumber: 'ACC-029',
      receiptDate: new Date(),
      receivedAmount: 9200.00,
      allocatedAmount: 9200.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'direct_debit',
      paymentReference: 'DD-20004',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-029',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 130,
      receiptNumber: 'RCP-030',
      customerId: 130,
      customerName: 'E-commerce Solutions',
      customerAccountNumber: 'ACC-030',
      receiptDate: new Date(),
      receivedAmount: 5600.00,
      allocatedAmount: 5600.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'credit_card',
      paymentReference: 'CC-20005',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-030',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 131,
      receiptNumber: 'RCP-031',
      customerId: 131,
      customerName: 'Data Analytics Corp',
      customerAccountNumber: 'ACC-031',
      receiptDate: new Date(),
      receivedAmount: 8900.00,
      allocatedAmount: 8900.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BT-20006',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-031',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 132,
      receiptNumber: 'RCP-032',
      customerId: 132,
      customerName: 'Mobile Apps Ltd',
      customerAccountNumber: 'ACC-032',
      receiptDate: new Date(),
      receivedAmount: 6300.00,
      allocatedAmount: 6300.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'credit_card',
      paymentReference: 'CC-20007',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-032',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 133,
      receiptNumber: 'RCP-033',
      customerId: 133,
      customerName: 'Web Design Studio',
      customerAccountNumber: 'ACC-033',
      receiptDate: new Date(),
      receivedAmount: 4200.00,
      allocatedAmount: 4200.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BT-20008',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-033',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 134,
      receiptNumber: 'RCP-034',
      customerId: 134,
      customerName: 'IT Infrastructure Inc',
      customerAccountNumber: 'ACC-034',
      receiptDate: new Date(),
      receivedAmount: 11200.00,
      allocatedAmount: 11200.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'direct_debit',
      paymentReference: 'DD-20009',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-034',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 135,
      receiptNumber: 'RCP-035',
      customerId: 135,
      customerName: 'Security Systems Co',
      customerAccountNumber: 'ACC-035',
      receiptDate: new Date(),
      receivedAmount: 7500.00,
      allocatedAmount: 7500.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'credit_card',
      paymentReference: 'CC-20010',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-035',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 136,
      receiptNumber: 'RCP-036',
      customerId: 136,
      customerName: 'Network Solutions Ltd',
      customerAccountNumber: 'ACC-036',
      receiptDate: new Date(),
      receivedAmount: 9800.00,
      allocatedAmount: 9800.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BT-20011',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-036',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 137,
      receiptNumber: 'RCP-037',
      customerId: 137,
      customerName: 'Business Intelligence Corp',
      customerAccountNumber: 'ACC-037',
      receiptDate: new Date(),
      receivedAmount: 6700.00,
      allocatedAmount: 6700.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'credit_card',
      paymentReference: 'CC-20012',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-037',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 138,
      receiptNumber: 'RCP-038',
      customerId: 138,
      customerName: 'AI Technologies Inc',
      customerAccountNumber: 'ACC-038',
      receiptDate: new Date(),
      receivedAmount: 13500.00,
      allocatedAmount: 13500.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BT-20013',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-038',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 139,
      receiptNumber: 'RCP-039',
      customerId: 139,
      customerName: 'Blockchain Solutions',
      customerAccountNumber: 'ACC-039',
      receiptDate: new Date(),
      receivedAmount: 8400.00,
      allocatedAmount: 8400.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'direct_debit',
      paymentReference: 'DD-20014',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-039',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 140,
      receiptNumber: 'RCP-040',
      customerId: 140,
      customerName: 'IoT Systems Ltd',
      customerAccountNumber: 'ACC-040',
      receiptDate: new Date(),
      receivedAmount: 5900.00,
      allocatedAmount: 5900.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'credit_card',
      paymentReference: 'CC-20015',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-040',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 141,
      receiptNumber: 'RCP-041',
      customerId: 141,
      customerName: 'Robotics Engineering',
      customerAccountNumber: 'ACC-041',
      receiptDate: new Date(),
      receivedAmount: 10500.00,
      allocatedAmount: 10500.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BT-20016',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-041',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 142,
      receiptNumber: 'RCP-042',
      customerId: 142,
      customerName: 'Automation Systems',
      customerAccountNumber: 'ACC-042',
      receiptDate: new Date(),
      receivedAmount: 7200.00,
      allocatedAmount: 7200.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'credit_card',
      paymentReference: 'CC-20017',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-042',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 143,
      receiptNumber: 'RCP-043',
      customerId: 143,
      customerName: 'Virtual Reality Co',
      customerAccountNumber: 'ACC-043',
      receiptDate: new Date(),
      receivedAmount: 9600.00,
      allocatedAmount: 9600.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BT-20018',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-043',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 144,
      receiptNumber: 'RCP-044',
      customerId: 144,
      customerName: 'Augmented Reality Ltd',
      customerAccountNumber: 'ACC-044',
      receiptDate: new Date(),
      receivedAmount: 6800.00,
      allocatedAmount: 6800.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'direct_debit',
      paymentReference: 'DD-20019',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-044',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 145,
      receiptNumber: 'RCP-045',
      customerId: 145,
      customerName: 'Machine Learning Inc',
      customerAccountNumber: 'ACC-045',
      receiptDate: new Date(),
      receivedAmount: 11800.00,
      allocatedAmount: 11800.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'credit_card',
      paymentReference: 'CC-20020',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-045',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
  ];
};

// Mock Transactions for Allocation
export const generateMockTransactions = (customerId: number): Transaction[] => {
  const transactions: Record<number, Transaction[]> = {
    // TEST TRANSACTIONS FOR PROMISE TO PAY (Phase 2)
    1: [
      {
        id: 1,
        transactionNumber: 'INV-2024-001',
        transactionType: 'invoice',
        customerId: 1,
        customerName: 'ABC Company Ltd',
        transactionDate: new Date('2024-12-01'),
        dueDate: new Date('2024-12-31'),
        originalAmount: 500.00,
        currentBalance: 500.00,
        currency: 'GBP',
        daysOverdue: 15,
        onDispute: false,
        promisedAmount: 500.00,
        isPromised: true,
      },
      {
        id: 2,
        transactionNumber: 'INV-2024-002',
        transactionType: 'invoice',
        customerId: 1,
        customerName: 'ABC Company Ltd',
        transactionDate: new Date('2024-12-05'),
        dueDate: new Date('2025-01-04'),
        originalAmount: 350.00,
        currentBalance: 350.00,
        currency: 'GBP',
        daysOverdue: 11,
        onDispute: false,
      },
      {
        id: 3,
        transactionNumber: 'INV-2024-003',
        transactionType: 'invoice',
        customerId: 1,
        customerName: 'ABC Company Ltd',
        transactionDate: new Date('2024-12-10'),
        dueDate: new Date('2025-01-09'),
        originalAmount: 450.00,
        currentBalance: 450.00,
        currency: 'GBP',
        daysOverdue: 6,
        onDispute: false,
        promisedAmount: 450.00,
        isPromised: true,
      },
      {
        id: 4,
        transactionNumber: 'INV-2024-004',
        transactionType: 'invoice',
        customerId: 1,
        customerName: 'ABC Company Ltd',
        transactionDate: new Date('2024-12-15'),
        dueDate: new Date('2025-01-14'),
        originalAmount: 275.00,
        currentBalance: 275.00,
        currency: 'GBP',
        daysOverdue: 1,
        onDispute: false,
      },
      {
        id: 5,
        transactionNumber: 'INV-2024-005',
        transactionType: 'invoice',
        customerId: 1,
        customerName: 'ABC Company Ltd',
        transactionDate: new Date('2024-12-20'),
        dueDate: new Date('2025-01-19'),
        originalAmount: 300.00,
        currentBalance: 300.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
        promisedAmount: 300.00,
        isPromised: true,
      },
      {
        id: 6,
        transactionNumber: 'INV-2024-006',
        transactionType: 'invoice',
        customerId: 1,
        customerName: 'ABC Company Ltd',
        transactionDate: new Date('2024-12-25'),
        dueDate: new Date('2025-01-24'),
        originalAmount: 425.00,
        currentBalance: 425.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
    ],
    // INVOICES FOR ACME DISTRIBUTION LTD (REC-001 Allocation)
    101: [
      {
        id: 1001,
        transactionNumber: 'INV-2547',
        transactionType: 'invoice',
        customerId: 101,
        customerName: 'Acme Distribution Ltd',
        transactionDate: new Date('2025-09-15'),
        dueDate: new Date('2025-10-15'),
        originalAmount: 2100.00,
        currentBalance: 2100.00,
        currency: 'GBP',
        daysOverdue: 26,
        onDispute: false,
      },
      {
        id: 1002,
        transactionNumber: 'INV-2501',
        transactionType: 'invoice',
        customerId: 101,
        customerName: 'Acme Distribution Ltd',
        transactionDate: new Date('2025-09-22'),
        dueDate: new Date('2025-10-22'),
        originalAmount: 1850.00,
        currentBalance: 1850.00,
        currency: 'GBP',
        daysOverdue: 19,
        onDispute: false,
      },
      {
        id: 1003,
        transactionNumber: 'INV-2465',
        transactionType: 'invoice',
        customerId: 101,
        customerName: 'Acme Distribution Ltd',
        transactionDate: new Date('2025-09-28'),
        dueDate: new Date('2025-10-28'),
        originalAmount: 950.00,
        currentBalance: 950.00,
        currency: 'GBP',
        daysOverdue: 13,
        onDispute: false,
      },
      {
        id: 1004,
        transactionNumber: 'INV-2420',
        transactionType: 'invoice',
        customerId: 101,
        customerName: 'Acme Distribution Ltd',
        transactionDate: new Date('2025-10-05'),
        dueDate: new Date('2025-11-04'),
        originalAmount: 3200.00,
        currentBalance: 3200.00,
        currency: 'GBP',
        daysOverdue: 6,
        onDispute: false,
      },
      {
        id: 1005,
        transactionNumber: 'INV-2380',
        transactionType: 'invoice',
        customerId: 101,
        customerName: 'Acme Distribution Ltd',
        transactionDate: new Date('2025-10-12'),
        dueDate: new Date('2025-11-11'),
        originalAmount: 1450.00,
        currentBalance: 1450.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
      {
        id: 1006,
        transactionNumber: 'INV-2340',
        transactionType: 'invoice',
        customerId: 101,
        customerName: 'Acme Distribution Ltd',
        transactionDate: new Date('2025-10-18'),
        dueDate: new Date('2025-11-17'),
        originalAmount: 2750.00,
        currentBalance: 2750.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
      {
        id: 1007,
        transactionNumber: 'INV-2300',
        transactionType: 'invoice',
        customerId: 101,
        customerName: 'Acme Distribution Ltd',
        transactionDate: new Date('2025-10-25'),
        dueDate: new Date('2025-11-24'),
        originalAmount: 1200.00,
        currentBalance: 1200.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
      {
        id: 1008,
        transactionNumber: 'INV-2260',
        transactionType: 'invoice',
        customerId: 101,
        customerName: 'Acme Distribution Ltd',
        transactionDate: new Date('2025-11-01'),
        dueDate: new Date('2025-12-01'),
        originalAmount: 3850.00,
        currentBalance: 3850.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
      {
        id: 1009,
        transactionNumber: 'INV-2220',
        transactionType: 'invoice',
        customerId: 101,
        customerName: 'Acme Distribution Ltd',
        transactionDate: new Date('2025-11-08'),
        dueDate: new Date('2025-12-08'),
        originalAmount: 875.00,
        currentBalance: 875.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
      {
        id: 1010,
        transactionNumber: 'INV-2180',
        transactionType: 'invoice',
        customerId: 101,
        customerName: 'Acme Distribution Ltd',
        transactionDate: new Date('2025-11-15'),
        dueDate: new Date('2025-12-15'),
        originalAmount: 2100.00,
        currentBalance: 2100.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
      {
        id: 1011,
        transactionNumber: 'INV-2140',
        transactionType: 'invoice',
        customerId: 101,
        customerName: 'Acme Distribution Ltd',
        transactionDate: new Date('2025-11-22'),
        dueDate: new Date('2025-12-22'),
        originalAmount: 1650.00,
        currentBalance: 1650.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
      {
        id: 1012,
        transactionNumber: 'INV-2100',
        transactionType: 'invoice',
        customerId: 101,
        customerName: 'Acme Distribution Ltd',
        transactionDate: new Date('2025-11-29'),
        dueDate: new Date('2025-12-29'),
        originalAmount: 3200.00,
        currentBalance: 3200.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
    ],
    102: [
      {
        id: 2001,
        transactionNumber: 'INV-2001',
        transactionType: 'invoice',
        customerId: 102,
        customerName: 'Tech Solutions Inc',
        transactionDate: subDays(new Date(), 50),
        dueDate: subDays(new Date(), 20),
        originalAmount: 2500.00,
        currentBalance: 1200.00,
        currency: 'GBP',
        daysOverdue: 20,
        onDispute: false,
      },
      {
        id: 2002,
        transactionNumber: 'INV-2010',
        transactionType: 'invoice',
        customerId: 102,
        customerName: 'Tech Solutions Inc',
        transactionDate: subDays(new Date(), 30),
        dueDate: new Date(),
        originalAmount: 1800.00,
        currentBalance: 1800.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
      {
        id: 2003,
        transactionNumber: 'INV-2015',
        transactionType: 'invoice',
        customerId: 102,
        customerName: 'Tech Solutions Inc',
        transactionDate: subDays(new Date(), 20),
        dueDate: addDays(new Date(), 10),
        originalAmount: 2200.00,
        currentBalance: 2200.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
    ],
    104: [
      {
        id: 4001,
        transactionNumber: 'INV-4001',
        transactionType: 'invoice',
        customerId: 104,
        customerName: 'Manufacturing Co Ltd',
        transactionDate: subDays(new Date(), 60),
        dueDate: subDays(new Date(), 30),
        originalAmount: 5000.00,
        currentBalance: 5000.00,
        currency: 'GBP',
        daysOverdue: 30,
        onDispute: false,
      },
      {
        id: 4002,
        transactionNumber: 'INV-4010',
        transactionType: 'invoice',
        customerId: 104,
        customerName: 'Manufacturing Co Ltd',
        transactionDate: subDays(new Date(), 45),
        dueDate: subDays(new Date(), 15),
        originalAmount: 4500.00,
        currentBalance: 4500.00,
        currency: 'GBP',
        daysOverdue: 15,
        onDispute: false,
      },
      {
        id: 4003,
        transactionNumber: 'INV-4020',
        transactionType: 'invoice',
        customerId: 104,
        customerName: 'Manufacturing Co Ltd',
        transactionDate: subDays(new Date(), 30),
        dueDate: new Date(),
        originalAmount: 3000.00,
        currentBalance: 3000.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
    ],
  };

  return transactions[customerId] || [];
};
